import { createContext, useCallback, useState } from 'react';
import { CountryOption } from '../mytm/country/country';

const DEFAULT_COUNTRY = [
  {
    code: 'USA',
    name: 'United States',
    status: 'ACTIVE',
  },
  {
    code: 'CAN',
    name: 'Canada',
    status: 'ACTIVE',
  },
];

interface DefaultContextCountry {
  countryList: CountryOption[];
  updateCountryList: (data: CountryOption[]) => void;
}

const DEFAULT_CONTEXT: DefaultContextCountry = {
  countryList: DEFAULT_COUNTRY,
  updateCountryList: (data: any) => {},
};

export const CountryContext = createContext(DEFAULT_CONTEXT);

export function useCountryContext(): DefaultContextCountry {
  const [countryList, setCountryList] = useState(DEFAULT_COUNTRY);
  const updateCountryList = useCallback((data): void => {
    setCountryList(data);
  }, []);

  return {
    countryList,
    updateCountryList,
  };
}
